var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5298 58.0319H14.6904C8.10545 58.0319 2.74805 52.6745 2.74805 46.0895V28.9982C2.74805 25.2155 4.56735 21.6193 7.61475 19.3776L22.6919 8.2893C26.9243 5.1765 32.6108 5.1775 36.8433 8.2893L51.92 19.3777C52.8096 20.0325 53.0006 21.2839 52.3463 22.1741C51.691 23.0637 50.4396 23.2527 49.5499 22.6004L34.4731 11.5119C31.6582 9.4416 27.8759 9.4416 25.062 11.5119L9.98495 22.6003C7.95805 24.0905 6.74805 26.4826 6.74805 28.9982V46.0895C6.74805 50.4694 10.311 54.0319 14.6904 54.0319H29.5298C30.6343 54.0319 31.5298 54.9274 31.5298 56.0319C31.5298 57.1364 30.6343 58.0319 29.5298 58.0319Z",
    fill: "#012124"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4985 26.5254C36.812 26.5254 29.7451 33.5918 29.7451 42.2783C29.7451 50.9648 36.812 58.0322 45.4985 58.0322C54.185 58.0322 61.252 50.9648 61.252 42.2783C61.252 33.5918 54.1851 26.5254 45.4985 26.5254ZM51.0732 44.7988H47.4985V48.373C47.4985 49.4775 46.603 50.373 45.4985 50.373C44.394 50.373 43.4985 49.4775 43.4985 48.373V44.7988H39.9238C38.8193 44.7988 37.9238 43.9033 37.9238 42.7988C37.9238 41.6943 38.8193 40.7988 39.9238 40.7988H43.4985V37.2236C43.4985 36.1191 44.394 35.2236 45.4985 35.2236C46.603 35.2236 47.4985 36.1191 47.4985 37.2236V40.7988H51.0732C52.1777 40.7988 53.0732 41.6943 53.0732 42.7988C53.0732 43.9033 52.1777 44.7988 51.0732 44.7988Z",
    fill: "#012124",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHome);
export default __webpack_public_path__ + "static/media/new-home.5964617d3d72b8aef9819e7d038d631c.svg";
export { ForwardRef as ReactComponent };